import React from "react";

const Header = () => (
  <header className="medium-gradient">
    <a className="gtm-global-logo" href="/"><img id="logo" src="/images/logo-ucla.svg" alt="UCLA College Admission Tips" /></a>
  </header>
);

export default Header;
